// Doble Uve · ficha de producto: formatos, cantidad, añadir al carrito, galería,
// barra de compra fija y lectura de la descripción (Descripción, Ingredientes y Alérgenos).
const { $, $$, dinero, anadir, reducido, escapar } = window.DBU;
const pdp = $('[data-pdp]');

if (pdp) {
  const datos = JSON.parse($('#pdp-datos').textContent);
  const porId = Object.fromEntries(datos.variantes.map((v) => [String(v.id), v]));
  const marcada = $('#variantes [aria-checked="true"]') || $('#variantes .opcion:not([disabled])');
  const est = { variante: marcada ? marcada.dataset.variante : String(datos.variantes[0].id), cantidad: 1 };

  // ---------- Descripción: se separa en descripción, ingredientes y alérgenos ----------
  const ALERGENOS = [
    ['gluten', /gluten/i], ['huevo', /huevo/i], ['lácteos', /l[aá]cteo|lactosa|leche/i],
    ['frutos de cáscara', /frutos (de c[aá]scara|secos)|almendra|avellana|nuez|nueces|pistacho/i], ['sésamo', /s[eé]samo/i],
    ['soja', /soja/i], ['mostaza', /mostaza/i], ['pescado', /pescado/i], ['sulfitos', /sulfito/i],
  ];
  const aTexto = (html) => {
    const t = html.replace(/<br\s*\/?>/gi, '\n').replace(/<\/(p|div|li|h\d)>/gi, '\n').replace(/<[^>]+>/g, '');
    const ta = document.createElement('textarea');
    ta.innerHTML = t;
    return ta.value.replace(/[\u{1F300}-\u{1FAFF}]/gu, '').replace(/[ \t]+/g, ' ').replace(/ *\n */g, '\n').replace(/\n{2,}/g, '\n').trim();
  };
  const caja = $('#descripcion');
  const t = aTexto(caja.innerHTML);
  // Solo cuentan como sección al principio de línea ("elaborado con ingredientes naturales" no lo es)
  const inicio = (re) => { const m = t.match(re); return m ? m.index + m[1].length : -1; };
  const iIng = inicio(/(^|\n)\s*ingredientes\s*:?/i);
  const iAle = inicio(/(^|\n)\s*al[eé]rgenos\s*:?/i);
  const descripcion = (iIng >= 0 ? t.slice(0, iIng) : iAle >= 0 ? t.slice(0, iAle) : t)
    .split('\n').filter((l) => !/mejor (rosc|panettone)|^premio/i.test(l)).join('\n').trim();
  const ingredientes = iIng >= 0 ? t.slice(iIng, iAle > iIng ? iAle : undefined).replace(/^\s*ingredientes\s*:?\s*/i, '').trim() : '';
  const aleTexto = iAle >= 0 ? t.slice(iAle).replace(/^\s*al[eé]rgenos\s*:?\s*/i, '').trim() : '';
  const [contiene, trazasTexto = ''] = aleTexto.split(/puede contener/i);
  const alergenos = ALERGENOS.filter(([, re]) => re.test(contiene)).map(([n]) => n);
  const trazas = ALERGENOS.filter(([, re]) => re.test(trazasTexto)).map(([n]) => n);

  if (iIng >= 0 || iAle >= 0) caja.innerHTML = descripcion.split('\n').filter(Boolean).map((p) => `<p>${escapar(p)}</p>`).join('');
  if (ingredientes) { $('#ingredientes').textContent = ingredientes; $('#acordeon-ingredientes').hidden = false; }
  const chips = (lista, clase = '') => lista.map((a) => `<span class="chip-alergeno${clase}">${a}</span>`).join('');
  if (alergenos.length || trazas.length) {
    $('#alergenos').innerHTML = `${alergenos.length ? `<p class="pdp__etiqueta">Contiene</p><div class="chips-alergenos">${chips(alergenos)}</div>` : ''}
      ${trazas.length ? `<p class="pdp__etiqueta">Puede contener trazas de</p><div class="chips-alergenos">${chips(trazas, ' chip-alergeno--trazas')}</div>` : ''}`;
    $('#acordeon-alergenos').hidden = false;
  }
  if (alergenos.length) $('#alergenos-rapidos').innerHTML = `<span class="pdp__etiqueta">Contiene</span>${chips(alergenos)}`;
  $$('[data-alergenos-texto]').forEach((el) => { if (alergenos.length) el.textContent = alergenos.join(', '); });

  // ---------- Datos clave: solo lo que dice la descripción real ----------
  const todo = `${t}`.toLowerCase();
  const ferm = t.match(/(\d+)\s*horas? de fermentaci[oó]n en bloque a (\d+)\s*grados y (\d+)\s*h\w*\s*(?:en pieza\s*)?en fr[ií]o/i);
  const claves = [];
  if (pdp.dataset.premioAnio && $('.etiqueta-premio--grande')) claves.push(['Premiado', pdp.dataset.premioAnio]);
  if (/m[aá]s de tres d[ií]as/.test(todo)) claves.push(['Más de 3 días', 'de elaboración']);
  if (ferm) claves.push([`${Number(ferm[1]) + Number(ferm[3])} h`, 'de fermentación']);
  if (/masa madre/.test(ingredientes.toLowerCase())) claves.push(['Masa madre', 'propia']);
  // Solo si lo ecológico es la harina (en el Chocottone lo ecológico es la vainilla)
  if (/harina[^,.;]*ecol[oó]gic|ecol[oó]gica[^,.;]*(trigo|harina)/.test(todo)) claves.push(['Harina', 'ecológica']);
  if (/sin conservantes/.test(todo)) claves.push(['Sin conservantes', 'ni colorantes']);
  if (/no contiene gluten en sus ingredientes/.test(todo)) claves.push(['Sin gluten', 'en sus ingredientes']);
  if (/mantequilla francesa/.test(todo)) claves.push(['Mantequilla', 'francesa']);
  if (/100% mantequilla/.test(todo)) claves.push(['100%', 'mantequilla']);
  if (claves.length) {
    $('#claves').innerHTML = claves.slice(0, 4).map(([a, b]) => `<li><strong>${a}</strong><span>${b}</span></li>`).join('');
    $('#claves').hidden = false;
  }
  // El mensaje de masa madre de "Por qué es distinto" solo si la lleva
  if (ingredientes && !/masa madre/i.test(ingredientes)) $$('.pdp-distinto__mensaje').forEach((m) => { m.hidden = true; });

  // ---------- Estado de compra ----------
  const variante = () => porId[est.variante];
  const actualizar = () => {
    const v = variante();
    const total = dinero(v.precio * est.cantidad);
    $('#precio').textContent = dinero(v.precio * est.cantidad);
    if ($('#barra-precio')) $('#barra-precio').textContent = v.disponible ? dinero(v.precio) : 'Agotado';
    if ($('#cantidad')) $('#cantidad').textContent = est.cantidad;
    $$('#variantes .opcion').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.variante === est.variante)));
    const boton = $('#boton-anadir');
    const barra = $('#barra-boton');
    if (!boton) return;
    // El día y la franja se eligen en el carrito, para todo el pedido
    boton.disabled = !v.disponible;
    boton.textContent = v.disponible ? `Añadir al pedido · ${total}` : 'Agotado';
    if (barra) barra.textContent = 'Añadir';
  };

  const comprar = async () => {
    const v = variante();
    if (!v.disponible) return;
    const item = { id: v.id, quantity: est.cantidad };
    const ok = await anadir([item], { abrir: true, boton: $('#boton-anadir'), nombre: v.producto });
    if (ok) actualizar();
  };

  document.addEventListener('click', (ev) => {
    const o = ev.target.closest('#variantes [data-variante]');
    if (o && !o.disabled) { est.variante = o.dataset.variante; actualizar(); return; }
    const c = ev.target.closest('[data-pdp-cant]');
    if (c) { est.cantidad = Math.max(1, Math.min(20, est.cantidad + Number(c.dataset.pdpCant))); actualizar(); return; }
    const m = ev.target.closest('[data-ir-foto]');
    if (m) { $(`#foto-${m.dataset.irFoto}`)?.scrollIntoView({ behavior: reducido() ? 'auto' : 'smooth', block: 'center', inline: 'center' }); return; }
    if (ev.target.closest('#boton-anadir') || ev.target.closest('#barra-boton')) { comprar(); return; }
    const ir = ev.target.closest('[data-ir-compra]');
    if (ir) {
      ev.preventDefault();
      ($('#avisame') && !$('#compra:not([hidden])') ? $('#avisame') : $('.pdp__info')).scrollIntoView({ behavior: reducido() ? 'auto' : 'smooth', block: 'start' });
    }
  });

  // ---------- Galería: la miniatura activa sigue a la foto visible ----------
  let observador;
  const movil = matchMedia('(max-width: 899px)');
  const marcar = (i) => {
    $$('.pdp__mini').forEach((b) => b.setAttribute('aria-current', String(Number(b.dataset.irFoto) === i)));
    $$('.pdp__contador span').forEach((s, j) => s.classList.toggle('activo', j === i));
  };
  const observarGaleria = () => {
    observador?.disconnect();
    observador = new IntersectionObserver((entradas) => {
      const visible = entradas.filter((x) => x.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (visible) marcar(Number(visible.target.dataset.i));
    }, movil.matches ? { root: $('#fotos'), threshold: 0.6 } : { rootMargin: '-40% 0px -40% 0px', threshold: 0 });
    $$('.pdp__foto[data-i]').forEach((f) => observador.observe(f));
  };
  if ($$('.pdp__foto[data-i]').length > 1) {
    observarGaleria();
    movil.addEventListener('change', observarGaleria);
  }

  // ---------- Barra de compra fija cuando el botón principal sale de la vista ----------
  const barraCompra = $('#barra-compra');
  if (barraCompra && $('.pdp__compra')) {
    new IntersectionObserver(([en]) => barraCompra.classList.toggle('visible', !en.isIntersecting && en.boundingClientRect.top < 0))
      .observe($('.pdp__compra'));
  }

  // Tras enviar "Avísame", se vuelve a la ficha: lleva al mensaje
  if (/contact_posted|form_type=contact/.test(location.search) || $('#avisame [aria-invalid="true"]')) {
    $('#avisame')?.scrollIntoView({ block: 'center' });
  }

  actualizar();
}
